import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, FormArray, Validators, FormBuilder } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { ProvisionSchoolUserComponent } from '../forms/provisionSchoolUser/ctl.provision.schooluser.component';
import { ProjectmanagementService } from '../../../../../projects/projectmanagement/src/app/service/projectmanagement.service';
import { SchoolManagementService } from '../service/schoolmanagement.service';
import { UserManagementService } from '../../../../tools/src/service/user.management.service';
import { SchoolService } from '../service/school.service';

import { AddGradeClassComponent } from '../forms/schoolGradeClass/ctl.school.gradeclass.component';
import { AddGradeSubjectComponent } from '../forms/schoolGradeSubject/ctl.school.gradesubject.component';
import { CtlAssignTeacherComponent } from '../forms/schoolAssignTeacher/ctl.assign.teacher.component';
import { Dialog } from '@eds/vanilla';

@Component({
  selector: 'app-setupyourschool',
  templateUrl: './setupyourschool.component.html',
  styleUrls: ['./setupyourschool.component.css'],
  providers: [ProjectmanagementService, SchoolManagementService, SchoolService, UserManagementService]
})

export class SetupYourSchoolComponent implements OnInit {

  loggedInUser: any;
  @ViewChild (AddGradeClassComponent)
    private formGradeClass: AddGradeClassComponent;
  @ViewChild (AddGradeSubjectComponent)
    private formGradeSubject: AddGradeSubjectComponent;
  @ViewChild (ProvisionSchoolUserComponent)
    private provisionUser: ProvisionSchoolUserComponent;
  @ViewChild (CtlAssignTeacherComponent)
    private assignTeacher: CtlAssignTeacherComponent;

  fgAssignTeacher: FormGroup;

  loaded = false;
  project_id: string;
  school_id: string;
  projectData: any;
  schoolData: any;
  currentSteps = 1;
  gradeList: any[] = [];
  currentGrade = 0;
  xlssample: any;
  enablecomplete = false;
  stepMessage = '';
  nextbtnClicked = false;
  loadedGradeSubject = false;
  loadedGradeClass = false;
  importSuccess = false;
  setupComplete = false;
  successMessage="";
  wizardSteps = [
    'Add school classes',
    'Assign subjects',
    'Add students & teachers',
    'Assign teachers'
  ];

  btnTextAdd;
  btnTextCancel;
  titleModal;
  confirmEnable = false;
  selectedGrade: any;
  selectedSubjectList = [];
  subjectList: any[];

  curGrade: any;
  curClass: any;

  userListData: any[];
  teacherList: any[];
  roleListData: any[];

  studentCount: string;
  teacherCount: string;
  titleMessage: string;
  subTitleMessage: string;
  detailMessage: string;
  refresh: boolean;
  refreshGradeSubject: boolean;
  refreshAssignTeacher: boolean;
  firstStepConfirm = false;
  skipAndComplete = false;
  // @ViewChildren(AddTeachersAndStudentsComponent) addTeachersAndStudentsComponent:AddTeachersAndStudentsComponent;
  yearList;
  initialGradeList = [];
  subjectsList = [];
  status;
  btnStatusSave = true;
  enablePreview = false;
  sessionClasses = [];
  tempCollection;
  tempLoginCollection;
  teacherClassMapping = [];
  loginObj;
  schoolCode;
  classMapping = {};
  isEditMode = false;
  isEditModeBackStep = false;
  isAddGradeValidForm = true;

  isSelectSubjectValidForm = false;
  isAssignTeacherValidForm = false;
  teacherClassIndex = 0;
  classList = [];
  subjectTeacherAssigned: any[] = [];
  assignmentList: any[];
  detailMessage1: string;
  detailMessage2: string;
  textDir:any;
  school_name="";
  gradeSubjectListTemp: any[] = [];
  constructor(
    private _fb: FormBuilder,
    private projectService: ProjectmanagementService,
    private schoolManagementService: SchoolManagementService,
    private schoolService: SchoolService,
    private userService: UserManagementService,
    public translate: TranslateService,
    private _router: Router,
    private route: ActivatedRoute) {

    // this.activateModal();
    this.textDir = sessionStorage.getItem('textDir');
  }

  activateModal() {
    // jQuery('modal').on('onClose', function () {
    //   ////debugger;
    //   // do your work over here
    //   console.log('modal is closed hidden');
    // });
  }

  ngOnInit() {
    // const body = document.getElementsByTagName('body')[0];
    // body.classList.add('bodyBG');   // add the class

    // jQuery('[data-toggle="tooltip"]').tooltip();

    if (window.localStorage.getItem('loginInfoObj') == null) {
      console.log('token info missing');
      this._router.navigate(['/login']);
      return true;
    }

    this.fgAssignTeacher = this._fb.group({
      grade_id: [''],
      class_id: [''],
      subjectteacher: this._fb.array([])
    });

    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
   // console.log('Login User Detail ' + JSON.stringify(userData));
    this.loggedInUser = userData;
    this.getRoleList();
    this.route.params.subscribe(params => {
      if (params['project_id']) {
        this.project_id = params['project_id'];
      }
      if (params['school_id']) {
        this.school_id = params['school_id'];
      }

      if (!this.project_id && !this.school_id && userData && userData.project && userData.project._id) {
        //this.loggedInUser = userData;
        if (userData.project) {
          this.project_id = userData.project._id;
        }
        if (userData.school) {
          this.school_id = userData.school._id;
        }
      }
      this.getSchoolDetails(this.school_id);
      this.getProjectData(this.project_id);
      this.getGradeList(this.school_id);
    });

    if (this.currentSteps === 1) {
      if (this.formGradeClass) {
        this.formGradeClass.loaded = false;
        this.formGradeClass.school_id = this.school_id;
        this.formGradeClass.getGradeClassList();
      }
    }
  }
  ngAfterViewInit() {
    if (this.currentSteps === 1) {
      if (this.formGradeClass ) {
        this.formGradeClass.loaded = false;
        this.formGradeClass.school_id = this.school_id;
        this.formGradeClass.getGradeClassList();
      }
    }
    if(this.currentSteps === 3 ){
      this.provisionUser.nextBtnClicked = false;
    }
  }
  ngAfterViewChecked() {
    if (this.currentSteps === 1) {
      if (this.formGradeClass && !this.loadedGradeClass ) {
        this.formGradeClass.loaded = false;
        this.formGradeClass.school_id = this.school_id;
        this.formGradeClass.getGradeClassList();
        this.loadedGradeClass = true;
      }
    }
    if (this.currentSteps === 2 && !this.loadedGradeSubject) {
     // console.log('==== viewcheck ====');
      if (this.formGradeSubject) {
        this.getGradeList(this.school_id);
        this.formGradeSubject.loaded = false;
        this.formGradeSubject.school_id = this.school_id;
        this.formGradeSubject.project_id = this.project_id;
        this.formGradeSubject.school_id = this.school_id;
        this.formGradeSubject.getSubjectList();
        this.formGradeSubject.getGradeSubjectList();
        this.formGradeSubject.gradeDataList = [];
        this.loadedGradeSubject = true;
      }
    }
  }

  ngDoCheck(){
    if (this.provisionUser && this.provisionUser.dataSampleLinkClicked && this.nextbtnClicked){
      // jQuery('#modalConfirm').modal('show');
      this.btnTextAdd = 'Ok';
      this.btnTextCancel = 'Cancel';
      this.openDialogModal('cancelImport');
      this.provisionUser.dataSampleLinkClicked = false;
    }
    if (this.assignTeacher && this.assignTeacher.setupCompleted){
      this.setupComplete = true;
      this.stepMessage = this.translate.instant('Step 4 complete');
      this.skipAndComplete = true;
    }
     if (this.assignTeacher && this.assignTeacher.isCancelSetup){

      this.cancelSetup();
    }
    
  }
  log(data){
    console.log('fgdfg');
    console.log(data);
  }
  getProjectData(project_id: string) {
    this.loaded = false;
    this.projectService.detail(this.project_id).subscribe(
      (response) => {
        this.projectData = response[0];
      },
      (err) => {
          console.log('ERROR: ' + err);
      },
      () => {
         // console.log('COMPLETED');
      }
    );
  }


  getSchoolDetails(school_id) {
    this.schoolService.detail(school_id).subscribe(
      (response) => {
        this.schoolData = response;
        this.school_name = this.schoolData.name;
        this.school_id=this.schoolData._id;
        console.log("school Name >>>>>>> "+JSON.stringify( this.schoolData))
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
      //  console.log('COMPLETED');
      }
    );
  }

  getGradeList(school_id) {
    this.schoolManagementService.listClass(school_id).subscribe(
      (response) => {
        this.gradeList = [];
        const classList = response;
        this.assignmentList = classList.slice();

        for (const myclass of classList) {
          if ( this.gradeList && this.gradeList.map((e) => e.name ).indexOf(myclass.grade.name) === -1) {
            this.gradeList.push(myclass.grade);
          }
        }

        let i = 0;
        for (const grade of this.gradeList) {
          this.gradeList[i].classes = [];
          this.gradeList[i].subjects = [];
          classList.forEach(item => {
            if (item.grade && grade._id === item.grade._id) {
              if (!this.gradeList[i].subjects.length) {
                this.gradeList[i].subjects = item.subjects;
                this.subjectsList = item.subjects;
              }
              if (item.subjectteacher && Object.keys(item.subjectteacher[0]).length) {
                this.gradeList[i].subjectteacher = true;
              }
              if ( this.gradeList[i].classes.map((e) =>  e.name).indexOf(item.name) === -1 ) {
                this.gradeList[i].classes.push({_id: item._id, name: item.name});
                this.classList = this.gradeList[i].classes;
              }
            }
          });
          i++;
        }
        this.loaded = true;
      },
      (err) => {
        this.loaded = true;
        console.log('ERROR: ' + err);
        // add error handler
      },
      () => {
        //console.log('COMPLETED');
      }
    );
  }
firstStep(){
  if (this.currentSteps === 1) {
    this.firstStepConfirm = true;
  }
}

nextBtnClickFunc(){
  this.confirmEnable = true;
  this.nextbtnClicked = true;
  this.stepMessage = '';
  if (this.formGradeClass){
    this.formGradeClass.nextClicked = true;
  }
 else if (this.formGradeSubject){
  this.formGradeSubject.nextBtnClicked = true;
 } else if (this.provisionUser){
  this.confirmEnable = false;
  this.provisionUser.nextBtnClicked = true;
 }
}


btnAssignStatus(flag){
   
  this.btnStatusSave = false;
  if (flag) {
    this.btnStatusSave = true;
  } else {
    this.btnStatusSave = false;
  }

}
skipStep3and4(){
  this.btnTextAdd = this.translate.instant('Confirm');
  this.btnTextCancel = 'Cancel';
 /*  this.titleMessage = 'Skip Steps 3 and 4?';
  this.detailMessage2 = 'Select OK to continue'; */
  this.openDialogModal('skipModal');
}
cancelModal(){
  this.closeDialogModal('cancelModal');
}
cancelSetup(){
  this.titleMessage = this.translate.instant('Cancel school set up?');
  this.subTitleMessage = this.translate.instant('This will remove your data and allow you to start school set up again.');
  this.btnTextAdd = this.translate.instant('Confirm');
  this.btnTextCancel= 'Cancel';
  this.openDialogModal('cancelModal');
}
cancelSetupConfirm(){
  // jQuery('#cancelModal').modal('hide');
  /* Delete all classes those are added during school setup */
  this.schoolManagementService.removeSetupCancelledClasses(this.school_id).subscribe(
    (response) => {

    },
    (err) => {
      this.loaded = true;
      console.log('ERROR: ' + err);
      // add error handler
    },
    () => {
      // console.log('COMPLETED');
    });
  this._router.navigate(['/projectmanagement',this.project_id, this.school_id,'view'], {relativeTo: this.route});
}
gotoStepComplete(){

  this.skipAndComplete = true;
  this.stepMessage = '';
  this.currentSteps = 5;
 // alert("gotoStepComplete")
  this.closeDialogModal('skipModal');
  // jQuery('#skipModal').modal('hide');
}
nextStep() {
    if (this.currentSteps === 1) {
      if (this.formGradeClass) {
        this.formGradeClass.loaded = false;
        this.formGradeClass.school_id = this.school_id;
        this.formGradeClass.submitGradeClass().then(res => {
          this.formGradeClass.getGradeClassList();
          this.loadedGradeClass = false;
          this.stepMessage = this.translate.instant('Step 1 complete');
          this.currentSteps++;
          this.nextbtnClicked = false;
        });
      }
    } else if (this.currentSteps === 2) {
      const data = [];
      this.gradeSubjectListTemp.forEach(item => {
        const subjectsArr = [];
        item.subjects.forEach(it=>{
          subjectsArr.push(it._id);
        });
        data.push({grade_id: item._id, subjects: subjectsArr}); 
      });

      this.schoolManagementService.addGradeSubject(data, this.school_id).subscribe(
        (response) => {
          console.log('Subjects added.');
        },
        (err) => {
          console.log('ERROR: ' + err);
        },
        () => {
          this.loadedGradeSubject = false;
          this.stepMessage = this.translate.instant('Step 2 complete');
          this.currentSteps++;
          this.nextbtnClicked = false;
          this.getGradeList(this.school_id);
        }
      );
    } else if (this.currentSteps === 3) {
        this.checkAndImport();
    } else if (this.currentSteps === 4) {
       
        if (this.assignTeacher.nextBtnClicked){
          this.stepMessage = this.translate.instant('Step 4 is complete');
          this.assignTeacher.showSetupComplete();
        }
    }
  }

  finalStepForSetupYourSchool() {
    window.localStorage.setItem('schoolSetupSuccess', this.school_id);
    this._router.navigate(['../view'], {relativeTo: this.route});
  }

  backStep() {
    this.nextbtnClicked = false;
    this.stepMessage = '';
    if (this.formGradeClass){
      this.formGradeClass.nextClicked = false;
    }
    else if (this.formGradeSubject){
      this.formGradeSubject.nextBtnClicked = false;
    }
    else if (this.provisionUser){
      this.provisionUser.nextBtnClicked = false;
      this.importSuccess = false; 
      this.provisionUser.resetXlsFile();
    }

    if (this.currentSteps === 1) {
      if (this.formGradeClass) {
        this.formGradeClass.loaded = false;
        this.formGradeClass.school_id = this.school_id;
        this.formGradeClass.getGradeClassList();
      }
    }
  }

  currentSelectedGrade(i) {
    if (i) {
      this.currentGrade = i;
    }
  }

  nextGrade() {
    const tabOld = document.getElementById('tab_head_' + this.currentGrade);
    tabOld.classList.remove('active');
    const tabOldData = document.getElementById('tab_default_' + this.currentGrade);
    tabOldData.classList.remove('active');
    this.currentGrade++;
    const tab = document.getElementById('tab_head_' + this.currentGrade);
    tab.classList.add('active');
    const tabData = document.getElementById('tab_default_' + this.currentGrade);
    tabData.classList.add('active');
    this.teacherClassIndex = 0;
  }

  previousGrade() {
    const tabOld = document.getElementById('tab_head_' + this.currentGrade);
    tabOld.classList.remove('active');
    const tabOldData = document.getElementById('tab_default_' + this.currentGrade);
    tabOldData.classList.remove('active');
    this.currentGrade--;
    const tab = document.getElementById('tab_head_' + this.currentGrade);
    tab.classList.add('active');
    const tabData = document.getElementById('tab_default_' + this.currentGrade);
    tabData.classList.add('active');
    this.teacherClassIndex = 0;
  }

  userDetailFileUploaded(data) {
    let studentDob = data.file.response.studentData;

    studentDob['Date of Birth']=studentDob['Date of Birth'];
    const str = studentDob['Date of Birth'].split('-');
    let temp = '';
    temp = str[0];
    str[0] = str[2];
    str[2] = temp;
    if(str[1]<10)
      str[1]='0'+str[1];
    if(str[0] <10)
      str[0]='0'+str[0]; 
    studentDob = str[2] + '-' + str[1] + '-' + str[0];
    data.file.response.studentData['Date of Birth'] = studentDob;
    this.importSuccess =  true;
    if (data) {
      this.xlssample = data.file.response;
    }
  }

  userDetailProvisioned(data) {
    //
  }
  cancelDelete(){
    // jQuery('#errorModal1').modal('hide');
  }
  skipcancelDelete(){
    this.closeDialogModal('skipModal');
  }

  moveBack(){

    this.nextbtnClicked= false;
    // jQuery('#errorModal1').modal('hide');

    if (this.provisionUser){
      this.provisionUser.nextBtnClicked = false;
      this.importSuccess = false;
      this.provisionUser.resetXlsFile();
     }
  }


  checkAndImport() {
    // send request to parse the file again
    const data = {
      importedFile: this.xlssample.file,
      school_id: this.school_id
    };

    this.schoolManagementService.importSchoolUserData(JSON.stringify(data)).subscribe(
      (response) => {
        this.titleMessage = this.translate.instant('Import Successful');
        this.subTitleMessage = this.translate.instant('You have imported:');
        this.detailMessage = '';

        this.studentCount =  this.xlssample.studentCount +' '+this.translate.instant('Students');
        this.teacherCount =  this.xlssample.teacherCount +' '+this.translate.instant('Teachers');

        this.closeDialogModal('cancelImport');
        this.currentSteps++;
        this.nextbtnClicked = false;
        this.getTeacherList();
        this.stepMessage = this.translate.instant('Step 3 complete');
        this.addAssignmentToForm();
      },
      (err) => {
        this.titleMessage  = this.translate.instant('Invalid Excel Details');
        this.subTitleMessage = this.translate.instant('Please check your excel document matches the template, and re-import.'); 
        this.detailMessage1 =  '';
        this.detailMessage2 =  '';
        this.openDialogModal('errorModal1');
      },
      () => {
      // console.log('COMPLETED');
      }
    );
  }

  cancelImport(option) {
    this.confirmEnable = option;
    this.closeDialogModal('cancelImport');
  }

  assignTeacherReady() {
    this.enablecomplete = true;
  }

  finalStep() {
    //
    this.assignTeacher.onAddAssignTeacher();
  }

  openGradeSubject(grade) {
    this.refreshGradeSubject = false;
    this.curGrade = grade;
    this.selectedSubjectList = [];
    grade.subjects.forEach(x => {
      this.selectedSubjectList.push({_id:x._id,name:x.name});
    });
    this.titleModal = grade.name;
    this.btnStatusSave = true;
    this.btnTextAdd = 'Assign';
    this.btnTextCancel = 'Cancel';
    this.openDialogModal('assignsubjectModal');
  }
  saveGradeSubjects() {
    if (this.curGrade && this.selectedSubjectList && this.selectedSubjectList.length) {
      const index = this.gradeSubjectListTemp.findIndex(x => x._id === this.curGrade._id);
      if (index === -1){
        this.gradeSubjectListTemp.push({_id: this.curGrade._id, name:this.curGrade.name ,classes:this.curGrade.classes ,subjects: this.selectedSubjectList});
      } else{
        this.gradeSubjectListTemp[index] = {_id: this.curGrade._id, name:this.curGrade.name ,classes:this.curGrade.classes ,subjects: this.selectedSubjectList};
      }
      this.refreshGradeSubject = true;
      this.closeDialogModal('assignsubjectModal');
    } else {
      console.log('nothing to add');
      // this.refresh = true;
    }
  }

  openAssignTeacher(grade) {
    console.log('grade ' + JSON.stringify(grade));
    this.getTeacherList();
    this.titleModal = grade.name + ', '+this.translate.instant('Class') +' '+ grade.classSelected.name;
    this.curGrade = grade;
    this.fgAssignTeacher.reset();
    this.fgAssignTeacher.get('subjectteacher').patchValue([this.patchSubjectTeacher('','')]);
    this.addAssignmentToForm();
    this.btnTextAdd = 'Save';
    this.btnTextCancel = 'Cancel';
    this.openDialogModal('assignteacherModal');
    // jQuery('#assignteacherModal').modal('show');
  }

  saveTeacherClass() {
    //
   // console.log('assignment ' + JSON.stringify(this.subjectTeacherAssigned));
     if (!this.subjectTeacherAssigned.length) {
       console.log('nothing to upload');
       return;
     }

     this.refreshAssignTeacher = false;
     this.schoolManagementService.assignClassSubjectTeacher(this.subjectTeacherAssigned, this.school_id).subscribe(
      (response) => {
        console.log('teacher assigned :' + JSON.stringify(response));
        // jQuery('#assignsubjectModal').modal('hide');
        this.getGradeList(this.school_id);
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        this.refreshAssignTeacher = true;
        // jQuery('#assignteacherModal').modal('hide');
      }
    );
  }

  closeModal(modal) {
    // jQuery('#' + modal).hide();
  }

  getTeacherList() {
    // filter for teacher
    // add school_id in search or params
    const filterList = { sort_by: '_id', sort_order: 'desc', filter_by: 'school_id', filter_value: this.school_id };

    // teacher filter
    filterList.filter_by = filterList.filter_by + ',' + 'role_id';
    const role_id = this.getRoleID('Teacher');
    filterList.filter_value = filterList.filter_value + ',' + role_id;

    this.userService.search(filterList).subscribe(
      (response) => {
        this.userListData = response;
        if (this.userListData && this.userListData.length) {
          this.teacherList = this.userListData.slice();
        }
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
       // console.log('COMPLETED');
      }
    );
  }

  getRoleList() {
    //
    this.userService.listRoles().subscribe(
      (response) => {
        this.roleListData = response;
      },
      (err) => {
        console.log('ERROR: ' + err );
      },
      () => {
       // console.log( 'COMPLETED' );
      }
    );
  }

  getRoleID(name: String) {
    if (this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i].name === name) {
          return this.roleListData[i]._id;
        }
      }
    }
    return;
  }

  getRightMargin(step) {
    switch (step) {
      case 1: {
        return '85px';
      }
      case 2: {
        return '0px';
      }
      case 3: {
        return '85px';
      }
      default: {
        return '0px';
      }
    }
  }

  addAssignmentToForm() {

    this.assignmentList.forEach(item=>{
      // this.curClass = {...item};
      //check if its new class
      //global array object
      // initilize fgAssignTeacher
      // create control subjectteacher
      const control = this.fgAssignTeacher.controls['subjectteacher'] as FormArray;
      // this.fgAssignTeacher.reset();
      this.fgAssignTeacher.get('class_id').patchValue(item.name);
      this.fgAssignTeacher.get('grade_id').patchValue(item.grade._id);
      this.fgAssignTeacher.get('subjectteacher').patchValue([this.patchSubjectTeacher('','','','','')]);
      item.subjects.forEach(element => {
        const subjectteacher = item.subjectteacher;
        const j = 0;
        const index = subjectteacher.findIndex(x => x.subject && x.subject._id === element._id);
        if (index > -1) {
          if (subjectteacher[index].firstteacher && subjectteacher[index].firstteacher._id) {
            subjectteacher[index].firstteacher.name = subjectteacher[index].firstteacher.first_name + ' ' + subjectteacher[index].firstteacher.last_name;
            if(subjectteacher[index].subject){
              control.push(this.patchSubjectTeacher(subjectteacher[index].subject, subjectteacher[index].firstteacher,'',item._id, item.grade._id));
            }
            
          } else {
            if(subjectteacher[index].subject){
              control.push(this.patchSubjectTeacher(subjectteacher[index].subject,'','',item._id, item.grade._id));
            }
          }
          subjectteacher.splice(index, 1);
        } else {
          control.push(this.patchSubjectTeacher(element,'','',item._id, item.grade._id));
        }
      });
    });
  }
  patchSubjectTeacher(s, t?, t_two?,cl?, gr?) {
    return this._fb.group({
      subject: s,
      teacher: t || '',
      teacher_two: t_two || '',
      class: cl || '' ,
      grade: gr || ''
    });
  }

  importUserTeacher(){
   // this.checkAndImport();
    this.nextBtnClickFunc();
  }

  bulkAssignTeacher(){
    const data = [];
    this.schoolManagementService.assignClassSubjectTeacher(data,this.school_id).subscribe(
      (response) => {

      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {}
    );
  }

  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }
}
